// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__0Xyhz","languageContainer":"styles_languageContainer__hHEk6"};